import React, { useEffect, useState } from "react";
import Axios from "axios";
import { Marker } from "react-leaflet";
import { boat } from "../Icons/icons";

/*
 * This component displays the boat rental markers on the map
 */
const BoatRentals = (props) => {
  const [boats, setBoats] = useState([]);

  useEffect(() => {
    Axios.get(
      "https://www.limfjordsraadet.dk/data/baadjollekajak-udlejning/"
    ).then((res) => {
      //console.log(res.data);
      const data = res.data.map((s) => {
        s.facilities = {
          da: s.facilities,
          de: s.facilities_de,
          en: s.facilities_en,
        };
        s.description = {
          da: s.description,
          de: s.descriptionDE,
          en: s.descriptionEN,
        };
        return s;
      });
      setBoats(data);
    });
  }, []);

  const boatMarkers =
    boats &&
    boats.map((x, i) => (
      <Marker
        key={i}
        position={{ lat: x.gps[0].lat, lng: x.gps[0].long }}
        onclick={() => props.onClick(x)}
        icon={boat}
        zIndexOffset={50}
      />
    ));
  return <div>{boatMarkers}</div>;
};

export default BoatRentals;
